import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../openapi';

@Pipe({
  name: 'shipmentContentPlaceholder',
  standalone: true
})
export class ShipmentContentPlaceholderPipe implements PipeTransform {

  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (application?.service?.url) {
      case '/uwaga-do-konsultowanego-projaktu-aktu-planowania-przestrzennego': {
        return 'Wpisz czego dotyczy uwaga (numer działki, obręb, swoje uwagi)';
      }
      case '/wniosek-o-zmiane-aktu-planowania-przestrzennego': {
        return 'Wpisz czego dotyczy zmiana';
      }
      default:
        return 'Wpisz tu treść pisma';
    }
  }

}
